import { type UserPolicyTypeEnumEnum } from '@/shared/api'

export const UserPolicyTypeEnum = {
  TermsOfUse: 1 as UserPolicyTypeEnumEnum,
  PrivacyPolicy: 2 as UserPolicyTypeEnumEnum,
  FacebookProfileDeletionGuide: 3 as UserPolicyTypeEnumEnum,
  Offer: 4 as UserPolicyTypeEnumEnum,
  Charter: 5 as UserPolicyTypeEnumEnum,
} as const
